// src/style.js
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  header: {
    marginBottom: theme.spacing(3), // This adds spacing between header and table
  },
  title: {
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
  },
}));

export default useStyles;
